// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: "/login",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  one: path(ROOTS_DASHBOARD, "/one"),
  two: path(ROOTS_DASHBOARD, "/two"),
  three: path(ROOTS_DASHBOARD, "/three"),
  four: path(ROOTS_DASHBOARD, "/four"),

  // leads: "/leads",
  home: "/home",
  customerProfile: "/customers",
  timeOffRequests: "/time-off-requests",
  employeeProfile: "/employees",
  schedules: "/schedules",
  shiftTemplate: "/shift-templates",
  contacts: "/contacts",
  jobs: "/jobs-reqs",
  applications: "/jobs-applications",
  postOrderEditor: "/post-order/editor",
  fleetVehicles: '/fleet/vehicles',
  insurancePolicies: '/insurance-policies',
  driverApprovalRequests: '/fleet/driver-approval-requests',
  certificateRequests: '/fleet/certificate-requests',
  fleetDrivers: '/fleet/drivers',
  fleetMaintenance: '/fleet/maintenance',
  // fleetTrips: '/fleet/trips',
  fleetFuelLogs: '/fleet/fuel-logs',
  fleetDashboard: '/fleet/dashboard',
  fleetWorkOrders: '/fleet/work-orders',
  fleetInspections: '/fleet/inspections',
  chat: '/chat',
  settings: '/my-profile/settings',
  // Site Tasks
  siteTaskDashboard: '/site-tasks/dashboard',
  siteTaskTemplates: '/site-tasks/templates',
  siteTaskAssignments: '/site-tasks/assignments',
  taskCompletionTemplates: '/site-tasks/completion-templates',
  
  // Site Tasks - Equipment
  equipmentList: '/site-tasks/equipment',
  equipmentForm: '/site-tasks/equipment/new',
  equipmentEdit: (id) => `/site-tasks/equipment/${id}/edit`,
  
  // Site Tasks - Detail Views
  shiftTaskDetail: (id) => `/site-tasks/shift-tasks/${id}`,
  incidentReportDetail: (id) => `/site-tasks/incidents/${id}`,
  
  // Site Tasks - Analytics
  taskPerformanceChart: '/site-tasks/analytics/performance',
  taskCategoryDistribution: '/site-tasks/analytics/category-distribution',
  incompleteTaskAnalysis: '/site-tasks/analytics/incomplete-tasks',
  roundPerformanceMetrics: '/site-tasks/analytics/round-performance',
  guardPerformanceView: '/site-tasks/analytics/guard-performance',
  
  // Site Tasks - Equipment Reports
  equipmentStatusReport: '/site-tasks/equipment/status-report',
  equipmentAnalytics: '/site-tasks/equipment/analytics',
  
  // Site Tasks - Gamification
  gamificationSettings: '/site-tasks/gamification/settings',
  gamificationLeaderboard: '/site-tasks/gamification/leaderboard',
  achievementBadges: '/site-tasks/gamification/achievements',
  gamificationReports: '/site-tasks/gamification/reports',
  
  // Notifications
  notifications: '/notifications',
  notificationTester: '/notifications/tester',

  // DAR (Daily Activity Reports)
  dar: {
    root: '/dar',
    list: '/dar',
    edit: (id) => `/dar/${id}/edit`,
    internal: (id) => `/dar/${id}/internal`,
    sendEmail: (id) => `/dar/${id}/send-email`,
  },
  emailTemplates: '/admin/email-templates',

  // myTasks: "/my-tasks",
  // contacts: "/contacts",
  // transactions: "/transaction",
  // loans: "/loan",
  // tasks: "/tasks",
  // opportunities: "/opportunity",
  // companySetting: "/settings",
  // taskTemplate: "/settings/task-templates",
  // tags: "/settings/tags",
  // integrations: "/settings/integrations",
  // opportunityDetails: (id) => path("", `/${id}`),
  // companySettingDetails: (id) => path("", `/settings/task-templates/${id}`),
  // // leadsdetails: (id) => path("", `/leads/${id}`),
  // contactdetails: (id) => path("", `/contacts/${id}`),
  // transactionsdetails: (id) => path("", `/${id}`),
  // tasksdetails: (id) => path("", `/tasks/${id}`),
  // realestate: path(ROOTS_DASHBOARD, "/realestate"),
  // loanDetails: (id) => path("", `/${id}`),
  // reporting: path(ROOTS_DASHBOARD, "/reporting"),
  // report: "/report",
  // settings: path(ROOTS_DASHBOARD, "/settings"),
  // opportunity: path(ROOTS_DASHBOARD, "/opportunity"),
  // transaction: path(ROOTS_DASHBOARD, "/transaction"),
  // everything: "/borrower-portal/everything",
  // myTransactions: "/borrower-portal/my-transactions",
  // userTasks: "/borrower-portal/tasks",
  userManagement: {
    root: path(ROOTS_DASHBOARD, "/user-management"),
    list: path(ROOTS_DASHBOARD, "/user-management/list"),
    new: path(ROOTS_DASHBOARD, "/user-management/new"),
    edit: (name) => path(ROOTS_DASHBOARD, `/user-management/${name}`),
    demoEdit: path(ROOTS_DASHBOARD, `/user-management/reece-chung`),
  },
};
